import { AfterViewInit, ChangeDetectorRef, Component, Input, OnInit, ViewChild } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { tap } from 'rxjs/operators';
import { UsuariosService } from 'src/app/services/usuarios.service';

@Component({
  selector: 'app-bitacora-paginas',
  templateUrl: './bitacora-paginas.component.html',
  styleUrls: ['./bitacora-paginas.component.scss']
})
export class BitacoraPaginasComponent implements OnInit{

  @Input() tipo: string;

  displayedColumnsBitacora: string[] = ['accion', 'nombreCompleto', 'fechaRegistro'];
  dataSourceBitacora = new MatTableDataSource([]);

  fechaInicio;
  fechaFin;

  totalSize = 0;
  page = 0;
  size = 10;
  totalPages = 1;


  @ViewChild(MatPaginator) paginator: MatPaginator;


  constructor(
    private servicioUsuario: UsuariosService,
    private cdr: ChangeDetectorRef
  ) { }

  ngOnInit(): void {
  }

  
  

  getBitacora() {


    const page = this.page || 0;
    const size = this.size || 10; 

    
    let fechaInicioFormatted = this.fechaInicio ? new Date(this.fechaInicio).toISOString().split('T')[0] : '';
    let fechaFinFormatted = this.fechaFin ? new Date(this.fechaFin).toISOString().split('T')[0] : '';

    let filtros = fechaInicioFormatted;

    if (fechaInicioFormatted) {
      filtros = `fechaInicio=${fechaInicioFormatted}`;
    }

    if (fechaFinFormatted) {
      filtros += `&fechaFin=${fechaFinFormatted}`;
    }

    this.servicioUsuario.getBitacora(filtros, this.tipo, page.toString(), size.toString()).subscribe({
      next: (data) => {
        console.log(data);

        const bitacora = data?.data?.content || [];
        const bitacoraNombres = bitacora.map((bitacora) => {
          let nombreCompleto = (!bitacora?.nombreCompleto || bitacora.nombreCompleto === 'null null null') ? '' : bitacora.nombreCompleto;
          return { ...bitacora, nombreCompleto };
        });

        const sortedLogs = bitacoraNombres.sort((a, b) => 
          new Date(b.fechaRegistro).getTime() - new Date(a.fechaRegistro).getTime()
        );
  
        this.dataSourceBitacora.data = sortedLogs;  

        this.totalSize = data.data.totalSize;
        this.totalPages = data.data.totalPages;

      },
      error: (error) => console.log(error),
      complete: () => {
        // this.fechaFin = null;
        // this.fechaInicio = null;
      },
    });

  }

  cambiarPagina(nuevaPagina: number) {
    if (nuevaPagina >= 0 && nuevaPagina < this.totalPages) {
      this.page = nuevaPagina;
      this.getBitacora();
    }
  }

  cambiarTamano(nuevoTamano: number) {
    this.size = nuevoTamano;
    this.page = 0; // Reiniciar a la primera página
    this.getBitacora();
  }


}
